var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.ready)?_c('v-icon',{attrs:{"color":_vm.statusIconData.color}},[_vm._v(_vm._s(_vm.statusIconData.icon))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }